<template>
  <div class="flex flex-col flex-1">
    <ZccVerticalAccordion>
      <template v-slot:title>
        <div class="flex flex-row justify-between flex-1">
          <h2 class="text-xl font-bold m-0 p-1">
            {{ title }}
          </h2>
          <div class="flex flex-row gap-6">
            <ZccInput
              class="flex flex-row gap-4 items-center content-center"
              :label="'Filter'"
              title="Verberg oude en inactieve diensten"
              :model-value="hideOldSchedules"
              @update:model-value="(value) => emit('update:modelValue', value)"
              :type="'checkbox'"
              id="checkbox"
            ></ZccInput>
          </div>
        </div>
      </template>

      <!-- Refactor this template to blend al the clusters into one schedule list per schedulegroup -->
      <template v-slot:content>
        <div class="flex flex-col gap-4 flex-1 mt-4 mx-10">
          <template v-if="!loading">
            <template v-if="hasSchedules()">
              <!-- cluster group names (headers)-->
              <div class="flex flex-row gap-4 flex-1">
                <div class="w-10"></div>
              </div>

              <template
                v-for="scheduleGroup in sortScheduleGroup(scheduleGroups)"
                v-bind:key="`scheduleGroup-${scheduleGroup.Name}`"
              >
                <ZccHorizontalAccordion
                  class="flex flex-row gap-4"
                  v-if="
                    scheduleGroup.Clusters && scheduleGroup.Clusters.length > 0
                  "
                  :scheduleGroupName="scheduleGroup.Name"
                >
                  <template v-slot:content>
                    <template
                      v-for="cluster in clusterSort(scheduleGroup.Clusters)"
                      v-bind:key="`cluster-${scheduleGroup.Name}-${cluster.Id}`"
                    >
                      <div
                        class="flex flex-col flex-1 min-w-[300px]"
                        v-if="scheduleGroup.Name.endsWith('D')"
                      >
                        <!-- information inside clusters -->
                        <div class="flex flex-col gap-2">
                          <template
                            v-for="scheduleDistrict in sortSchedulesOnDistrict(
                              cluster.Schedules
                            )"
                            v-bind:key="`scheduleDistrict-${cluster.Id}-${scheduleDistrict.Name}`"
                          >
                            <div class="flex flex-row gap-2">
                              <font-awesome-icon
                                :icon="['fas', 'location-dot']"
                                class="py-1"
                              />
                              <span class="font-bold text-lg">{{
                                scheduleDistrict.Name
                              }}</span>
                            </div>
                            <template
                              v-for="schedule in scheduleDistrict.Schedules"
                              v-bind:key="`schedule-${cluster.Id}-${scheduleDistrict.Name}-${schedule.Id}`"
                            >
                              <ZccSchedule
                                :schedule="schedule"
                                :activeScheduleId="activeScheduleId"
                                :setActiveScheduleId="setActiveScheduleId"
                              ></ZccSchedule>
                            </template>
                            <ZccAddSchedule
                              :date="date"
                              :cluster="cluster.DisplayName"
                              :schedule-group="scheduleGroup.Name"
                              :shift-uname="scheduleDistrict.Uname"
                            ></ZccAddSchedule>
                          </template>
                        </div>
                      </div>

                      <!-- information outside clusters -->
                      <template v-if="!scheduleGroup.Name.endsWith('D')">
                        <div
                          v-for="index in 3"
                          :key="`index-${cluster.Id}-${index}`"
                          class="flex flex-col flex-1 min-w-[300px] empty:hidden gap-2"
                        >
                          <template
                            v-for="(
                              schedule, indexSchedule
                            ) in sortSchedulesOnStartTime(
                              cluster.Schedules,
                              true
                            )"
                            v-bind:key="`schedule-${cluster.Id}-${schedule.Id}`"
                          >
                            <div
                              class="flex flex-col gap-2 empty:hidden"
                              v-if="
                                schedule.Id !== undefined &&
                                (index == indexSchedule + 1 ||
                                  (indexSchedule >= 3 &&
                                    indexSchedule - 2 == index) ||
                                  (indexSchedule >= 7 &&
                                    indexSchedule - 6 == index))
                              "
                            >
                              <ZccSchedule
                                :schedule="schedule"
                                :activeScheduleId="activeScheduleId"
                                :setActiveScheduleId="setActiveScheduleId"
                              ></ZccSchedule>
                            </div>
                            <div
                              class="flex flex-col"
                              v-if="
                                (cluster.Schedules.length ==
                                  indexSchedule + 1 &&
                                  index == indexSchedule + 2) ||
                                (cluster.Schedules.length == indexSchedule &&
                                  cluster.Schedules.length >= 3 &&
                                  index == indexSchedule - 2) ||
                                (cluster.Schedules.length == indexSchedule &&
                                  cluster.Schedules.length >= 7 &&
                                  index == indexSchedule - 6)
                              "
                            >
                              <ZccAddSchedule
                                :date="date"
                                :cluster="cluster.DisplayName"
                                :schedule-group="scheduleGroup.Name"
                                :shift-uname="'H'"
                              ></ZccAddSchedule>
                            </div>
                            <div
                              v-else
                              class="flex flex-col empty:hidden"
                            ></div>
                          </template>
                        </div>
                      </template>
                    </template>
                  </template>
                </ZccHorizontalAccordion> </template
            ></template>
            <template v-else>
              <p>Geen roosters gevonden</p>
            </template>
          </template>
          <template v-else>
            <div>Aan het laden...</div>
          </template>
        </div>
      </template>
    </ZccVerticalAccordion>
  </div>
</template>

<script lang="ts" setup>
import { Schedule, ScheduleGroup, Cluster } from "@planbord/shared/models";
import {
  ZccHorizontalAccordion,
  ZccSchedule,
  ZccVerticalAccordion,
  ZccInput,
  ZccAddSchedule,
} from "@planbord/ui/components";
import { ref } from "vue";
import { useSignalR } from "@dreamonkey/vue-signalr/dist/composable";

const activeScheduleId = ref<number | null>(null);

function setActiveScheduleId(id: number | null) {
  activeScheduleId.value = id;
}

const signalr = useSignalR();

signalr.on("addSchedule", (...messages) => {
  messages.forEach((schedule: Schedule) => {
    //check if the message has an id and if the date of the schedule is the same as the date of the schedule day
    if (
      schedule.Id &&
      new Date(schedule.DateTime).getDate() == props.date.getDate()
    ) {
      if (!schedule.Shift.ShiftGroup.DisplayName.startsWith("Zorgambulance")) {
        //get the start time of the schedule
        const startTime = new Date(schedule.StartTime);
        const endTime = new Date(schedule.EndTime);

        //get the middle of the start and end time of the schedule using the Date object
        const middleTime = new Date(
          startTime.getTime() + (endTime.getTime() - startTime.getTime()) / 2
        ).getHours();

        //HCA DD should be between 8 and 17
        if (middleTime >= 8 && middleTime < 17) {
          // add schedule to HCA DD
          addScheduleToRef(schedule, "DD");
        }
        //HCA AD should be between 17 and 23
        else if (middleTime >= 17 && middleTime <= 23) {
          // add schedule to HCA AD
          addScheduleToRef(schedule, "LD");
        }
        //HCA LD should also be from 13:00 to 21:00
        else if (middleTime >= 13 && middleTime <= 21) {
          // add schedule to HCA LD
          addScheduleToRef(schedule, "LD");
        }
        //HCA ND should be between 23 and 8
        else if (middleTime >= 23 || middleTime <= 8) {
          // add schedule to HCA ND
          addScheduleToRef(schedule, "ND");
        }
      } else {
        if (schedule.Shift.ShiftGroup.DisplayName.startsWith("Zorgambulance")) {
          addScheduleToRef(schedule, "Zorgambulance");
        }
      }
    }
  });
});

function addScheduleToRef(schedule: Schedule, scheduleGroupName: string) {
  //add schedule to the schedulegroups
  const scheduleGroup = scheduleGroups.value.find(
    (x: ScheduleGroup) => x.Name == scheduleGroupName
  );
  if (!scheduleGroup) return;
  const cluster = scheduleGroup.Clusters.find(
    (x: Cluster) => x.DisplayName == schedule.Shift.ShiftGroup.DisplayName
  );
  if (!cluster) return;
  if (!cluster.Schedules) {
    cluster.Schedules = [schedule];
  } else {
    cluster.Schedules = [...(cluster.Schedules || []), schedule];
  }
}

const props = defineProps<{
  title: string;
  date: Date;
  data: ScheduleGroup[];
  modelValue: unknown;
  loading: boolean;
}>();

//create a deep copy of the props data
const scheduleGroups = ref(JSON.parse(JSON.stringify(props.data)));

const hideOldSchedules = ref(props.modelValue);
const emit = defineEmits<{ (e: "update:modelValue", value: unknown): void }>();

function sortScheduleGroup(scheduleGroups: ScheduleGroup[]) {
  //create a new array with all the schedulegroups except the LCA schedulegroup
  const scheduleGroupsExceptZorgambulance = scheduleGroups.filter(
    (x) => !x.Name.startsWith("Zorgambulance")
  );

  //slice the schedulegroups until the HCA DD
  const scheduleGroupsUntilDD = scheduleGroupsExceptZorgambulance.slice(
    0,
    scheduleGroupsExceptZorgambulance.findIndex((x) =>
      x.Name.startsWith("DD")
    ) + 1
  );

  //slice the schedulegroups from the HCA DD
  const scheduleGroupsFromDD = scheduleGroupsExceptZorgambulance.slice(
    scheduleGroupsExceptZorgambulance.findIndex((x) =>
      x.Name.startsWith("DD")
    ) + 1
  );

  //get only LCA and MCA
  const scheduleGroupsZorgambulance = scheduleGroups.filter((x) =>
    x.Name.startsWith("Zorgambulance")
  );

  return [
    ...scheduleGroupsUntilDD,
    ...scheduleGroupsZorgambulance,
    ...scheduleGroupsFromDD,
  ];
}

type ScheduleDistrict = {
  Uname: string;
  Name: string;
  Schedules: Schedule[];
};

function sortSchedulesOnDistrict(schedules: Schedule[]) {
  //all the districts:
  //Almelo, Hellendoorn, Tubbergen, Vroomshoop, Enschede, Haaksbergen, Hengelo, Markelo, Oldenzaal, Midden Complex

  //create a new array with all the district names and the schedules that belong to that district
  const scheduleDistricts: ScheduleDistrict[] = [];

  //check if the schedules has atleast one schedule with a shift uname that starts with A
  if (schedules.some((x) => x.Shift.Uname.startsWith("A"))) {
    scheduleDistricts.push({
      Uname: "A",
      Name: "Almelo",
      Schedules: schedules
        .filter((x) => x.Shift.Uname.startsWith("A"))
        .sort((a, b) => a.Shift.Name.localeCompare(b.Shift.Name, undefined, { numeric: true, sensitivity: "base" })),
    });
  }
  //do this for all districts
  if (schedules.some((x) => x.Shift.Uname.startsWith("HD"))) {
    scheduleDistricts.push({
      Uname: "HD",
      Name: "Hellendoorn",
      Schedules: schedules
        .filter((x) => x.Shift.Uname.startsWith("HD"))
        .sort((a, b) => a.Shift.Name.localeCompare(b.Shift.Name, undefined, { numeric: true, sensitivity: "base" })),
    });
  }
  if (schedules.some((x) => x.Shift.Uname.startsWith("T"))) {
    scheduleDistricts.push({
      Uname: "T",
      Name: "Tubbergen",
      Schedules: schedules
        .filter((x) => x.Shift.Uname.startsWith("T"))
        .sort((a, b) => a.Shift.Name.localeCompare(b.Shift.Name, undefined, { numeric: true, sensitivity: "base" })),
    });
  }

  // Add Vroomshoop if there is any schedule where the Uname starts with "V" and is followed by one or more digits (e.g., "V2", "V12", "V23")
  if (
    schedules.some(
      (x) => /^V\d+$/.test(x.Shift.Uname)
    )
  ) {
    scheduleDistricts.push({
      Uname: "V",
      Name: "Vroomshoop",
      Schedules: schedules
        .filter(
          (x) => /^V\d+$/.test(x.Shift.Uname)
        )
        .sort((a, b) =>
          a.Shift.Name.localeCompare(b.Shift.Name, undefined, { numeric: true, sensitivity: "base" })
        ),
    });
  }
  if (schedules.some((x) => x.Shift.Uname.startsWith("HE") || x.Shift.Uname.startsWith("RO"))) {
    scheduleDistricts.push({
      Uname: "HE",
      Name: "Hengelo",
      Schedules: schedules.filter((x) => x.Shift.Uname.startsWith("HE") || x.Shift.Uname.startsWith("RO"))
          .sort((a, b) => a.Shift.Name.localeCompare(b.Shift.Name, undefined, { numeric: true, sensitivity: "base" })),
    });
  }
  if (schedules.some((x) => x.Shift.Uname.startsWith("VS"))) {
    scheduleDistricts.push({
      Uname: "VS",
      Name: "Verpleegkundig Specialist",
      Schedules: schedules
          .filter((x) => x.Shift.Uname.startsWith("VS"))
          .sort((a, b) =>
              a.Shift.Name.localeCompare(b.Shift.Name, undefined, { numeric: true, sensitivity: "base" })
          ),
    });
  }
  if (schedules.some((x) => x.Shift.Uname.startsWith("E"))) {
    scheduleDistricts.push({
      Uname: "E",
      Name: "Enschede",
      Schedules: schedules
        .filter((x) => x.Shift.Uname.startsWith("E"))
        .sort((a, b) => a.Shift.Name.localeCompare(b.Shift.Name, undefined, { numeric: true, sensitivity: "base" })),
    });
  }
  if (schedules.some((x) => x.Shift.Uname.startsWith("HA"))) {
    scheduleDistricts.push({
      Uname: "HA",
      Name: "Haaksbergen",
      Schedules: schedules
        .filter((x) => x.Shift.Uname.startsWith("HA"))
        .sort((a, b) => a.Shift.Name.localeCompare(b.Shift.Name, undefined, { numeric: true, sensitivity: "base" })),
    });
  }
  if (schedules.some((x) => x.Shift.Uname.startsWith("M"))) {
    scheduleDistricts.push({
      Uname: "M",
      Name: "Markelo",
      Schedules: schedules
        .filter((x) => x.Shift.Uname.startsWith("M"))
        .sort((a, b) => a.Shift.Name.localeCompare(b.Shift.Name, undefined, { numeric: true, sensitivity: "base" })),
    });
  }
  if (schedules.some((x) => x.Shift.Uname.startsWith("O"))) {
    scheduleDistricts.push({
      Uname: "O",
      Name: "Oldenzaal",
      Schedules: schedules
        .filter((x) => x.Shift.Uname.startsWith("O"))
        .sort((a, b) => a.Shift.Name.localeCompare(b.Shift.Name, undefined, { numeric: true, sensitivity: "base" })),
    });
  }
  //check if the shift uname starts with H and is followed by a number (H3, H10, H11, etc.)
  if (schedules.some((x) => x.Shift.Uname.startsWith("H") && /^H\d/.test(x.Shift.Uname))) {
    scheduleDistricts.push({
      Uname: "H",
      Name: "Midden Complex",
      Schedules: schedules
        .filter((x) => x.Shift.Uname.startsWith("H") && /^H\d/.test(x.Shift.Uname))
        .sort((a, b) => a.Shift.Name.localeCompare(b.Shift.Name, undefined, { numeric: true, sensitivity: "base" })),
    });
  }
  return scheduleDistricts;
}

function hasSchedules() {
  return scheduleGroups.value.some(
    (x: { Clusters: string | unknown[] }) => x.Clusters && x.Clusters.length > 0
  );
}

function sortSchedulesOnStartTime(schedules: Schedule[], addEmpty = false) {
  if (schedules && schedules.length > 1) {
    const sortedSchedules = [...schedules];

    //add empty schedule at the end of the array
    if (addEmpty) {
      sortedSchedules.push({} as Schedule);
    }

    return sortedSchedules.sort((x, y) => {
      return new Date(x.StartTime).getTime() - new Date(y.StartTime).getTime();
    });
  }
  return schedules;
}

function clusterSort(clusters: Cluster[]) {
  return [...(clusters ?? [])].sort((a, b) => {
    const aId = a.Id;
    const bId = b.Id;

    if (aId === 1043 && bId === 1046) return 1;   // Enschede NA Hengelo
    if (aId === 1046 && bId === 1043) return -1;  // Hengelo VOOR Enschede

    return aId - bId;
  });
}

</script>
